module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin_cyrillic-700.5afb8a61.eot";